import { createSlice } from "@reduxjs/toolkit"
import {
  getAllCountries,
  updateCountryStatus,
} from "store/actions/countriesAction"
import {
  getDashboardKpi,
  getDashboardKpiBookings,
  getDashboardKpiOrder,
  getDashboardKpiRatings,
  getEdiyahDashboard,
  getWalletDashboard,
} from "store/actions/dashboardAction"

const testData = {
  groupedData: [
    {
      _id: {
        giftCardId: "67a32bf65d1139fbd2db9d18",
      },
      name: "Eidiyah Card 30",
      nameAr: "عيدية 30 ريال",
      giftCardAmount: 30,
      totalPurchaseAmount: 1200,
      purchasedCount: 39,
      redeemedCount: 10,
      redeemedAmount: 300,
    },
    {
      _id: {
        giftCardId: "67a32c625d1139fbd2db9d2c",
      },
      name: "Eidiyah Card 100",
      nameAr: "عيدية 100 ريال",
      giftCardAmount: 100,
      totalPurchaseAmount: 4200,
      purchasedCount: 37,
      redeemedCount: 13,
      redeemedAmount: 1300,
    },
    {
      _id: {
        giftCardId: "67a32c405d1139fbd2db9d22",
      },
      name: "Eidiyah Card 50",
      nameAr: "عيدية 50 ريال",
      giftCardAmount: 50,
      totalPurchaseAmount: 1700,
      purchasedCount: 30,
      redeemedCount: 10,
      redeemedAmount: 500,
    },
    {
      _id: {
        giftCardId: "67a32c925d1139fbd2db9d36",
      },
      name: "Eidiyah Card 150",
      nameAr: "عيدية 150 ريال",
      giftCardAmount: 150,
      totalPurchaseAmount: 2700,
      purchasedCount: 18,
      redeemedCount: 6,
      redeemedAmount: 900,
    },
    {
      _id: {
        giftCardId: "67bc0472903e817ca1eeb68b",
      },
      name: "Ediyah 30 SAR",
      nameAr: "عيدية 30 ريال",
      giftCardAmount: 30,
      totalPurchaseAmount: 720,
      purchasedCount: 14,
      redeemedCount: 5,
      redeemedAmount: 150,
    },
    {
      _id: {
        giftCardId: "679db23aa0b9d18e1ee1dde5",
      },
      name: "Ediyah",
      nameAr: "العيدية",
      giftCardAmount: 50,
      totalPurchaseAmount: 350,
      purchasedCount: 5,
      redeemedCount: 1,
      redeemedAmount: 50,
    },
    {
      _id: {
        giftCardId: "679db27b588558c005308490",
      },
      name: "Ediyah",
      nameAr: "العيدية",
      giftCardAmount: 50,
      totalPurchaseAmount: 150,
      purchasedCount: 2,
      redeemedCount: 0,
      redeemedAmount: 0,
    },
  ],
  overallData: {
    _id: null,
    totalPurchaseAmount: 11020,
    totalPurchasedCount: 145,
    totalRedeemedCount: 45,
    totalRedeemedAmount: 3200,
    redemptionRate: 31.03,
    redeemAmountRate: 29.04,
    averageGiftCardValue: 76,
    topGiftCardName: "Eidiyah Card 30",
    topGiftCardAmount: 30,
    totalRedeemedCount: 45,
    totalUnredeemedCount: 123,
  },
  topGiftCardValues: [
    {
      name: "Eidiyah Card 150",
      nameAr: "عيدية 150 ريال",
      averageGiftCardValue: 150,
    },
    {
      name: "Eidiyah Card 100",
      nameAr: "عيدية 100 ريال",
      averageGiftCardValue: 113.51,
    },
    {
      name: "Ediyah",
      nameAr: "العيدية",
      averageGiftCardValue: 75,
    },
    {
      name: "Ediyah",
      nameAr: "العيدية",
      averageGiftCardValue: 70,
    },
    {
      name: "Eidiyah Card 50",
      nameAr: "عيدية 50 ريال",
      averageGiftCardValue: 56.67,
    },
  ],
}

const initialState = {
  loading: true,
  dashboardData: {},
  dashboardOrderData: {},
  dashboardBookingsData: {},
  dashboardRatingsData: {},
  ediyahDashboardData: {},
  walletDashboardData:{}
}

const usersSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: builder => {
    // GET DASHBOARD DATA
    builder
      .addCase(getDashboardKpi.pending, state => {
        state.loading = true
      })
      .addCase(getDashboardKpi.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload || {}
        if (status) {
          state.dashboardData = data
        }
      })
      .addCase(getDashboardKpi.rejected, (state, action) => {
        state.loading = false
      })

    // GET DASHBOARD ORDER DATA
    builder
      .addCase(getDashboardKpiOrder.pending, state => {
        state.loading = true
      })
      .addCase(getDashboardKpiOrder.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload || {}
        if (status) {
          state.dashboardOrderData = data
        }
      })
      .addCase(getDashboardKpiOrder.rejected, (state, action) => {
        state.loading = false
      })

    // GET DASHBOARD BOOKINGS DATA
    builder
      .addCase(getDashboardKpiBookings.pending, state => {
        state.loading = true
        state.dashboardBookingsData = {}
      })
      .addCase(getDashboardKpiBookings.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload || {}
        if (status) {
          state.dashboardBookingsData = data
        }
      })
      .addCase(getDashboardKpiBookings.rejected, (state, action) => {
        state.loading = false
      })

    // GET DASHBOARD RATINGS DATA
    builder
      .addCase(getDashboardKpiRatings.pending, state => {
        state.loading = true
        state.dashboardRatingsData = {}
      })
      .addCase(getDashboardKpiRatings.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload || {}
        if (status) {
          state.dashboardRatingsData = data
        }
      })
      .addCase(getDashboardKpiRatings.rejected, (state, action) => {
        state.loading = false
      })

    builder
      .addCase(getEdiyahDashboard.pending, state => {
        state.loading = true
        state.ediyahDashboardData = {}
      })
      .addCase(getEdiyahDashboard.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload || {}
        if (status) {
          state.ediyahDashboardData = data
        }
      })
      .addCase(getEdiyahDashboard.rejected, (state, action) => {
        state.loading = false
      })

    builder
      .addCase(getWalletDashboard.pending, state => {
        state.loading = true
        state.walletDashboardData = {}
      })
      .addCase(getWalletDashboard.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload || {}
        if (status) {
          state.walletDashboardData = data
        }
      })
      .addCase(getWalletDashboard.rejected, (state, action) => {
        state.loading = false
      })
  },
})

export default usersSlice.reducer
